/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetPss200Response,
} from '../models';
import {
    GetPss200ResponseFromJSON,
    GetPss200ResponseToJSON,
} from '../models';

export interface GetPssRequest {
    dc?: string;
    query?: string;
    tx?: boolean;
    type?: string;
}

/**
 * 
 */
export class PssApi extends runtime.BaseAPI {

    /**
     * Return configuration of all pss\' in a list
     * Return list of all pss\'
     */
    async getPssRaw(requestParameters: GetPssRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPss200Response>> {
        const queryParameters: any = {};

        if (requestParameters.dc !== undefined) {
            queryParameters['_dc'] = requestParameters.dc;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.tx !== undefined) {
            queryParameters['tx'] = requestParameters.tx;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/pss`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPss200ResponseFromJSON(jsonValue));
    }

    /**
     * Return configuration of all pss\' in a list
     * Return list of all pss\'
     */
    async getPss(requestParameters: GetPssRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPss200Response> {
        const response = await this.getPssRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
